import { AppBar, Dialog, IconButton, List, ListItemButton, ListItemText, Toolbar, Typography, colors } from '@mui/material';
import { useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';


import MenuIcon from '@mui/icons-material/Menu';

const itemSx = { py: '18px' };
const textSx = { fontSize: '1.4rem', fontWeight: 700 };

function MainMenu() {


  

  const [dialogOpen, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <IconButton
        id="basic-button"
        aria-controls={dialogOpen ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={dialogOpen ? 'true' : undefined}
        onClick={handleClickOpen}
        style = {{color: colors.common.white}}
        >
        <MenuIcon />
      </IconButton>
      <Dialog
       fullScreen
       open={dialogOpen}
       onClose={handleClickClose}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClickClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h2" component="div">
              FASA at VT
            </Typography>
          </Toolbar>
        </AppBar>
        <List>
          <ListItemButton component = "a" href='/' sx={itemSx}>
            <ListItemText primary="Home" primaryTypographyProps={textSx} />
          </ListItemButton>
          <ListItemButton component = "a" href = "/calendar" sx={itemSx}>
            <ListItemText primary = "Calendar" primaryTypographyProps={textSx}/>
          </ListItemButton>
          <ListItemButton component = "a" href='/board' sx={itemSx}>
            <ListItemText primary="Board" primaryTypographyProps={textSx}/>
          </ListItemButton>
          {/* <ListItemButton component = "a" href='/memberHighlight' sx={itemSx}>
            <ListItemText primary="Member Highlight" primaryTypographyProps={textSx}/>
          </ListItemButton> */}
          <ListItemButton component = "a" href = "/resources" sx={itemSx}>
            <ListItemText primary="Resources" primaryTypographyProps={textSx}/>
          </ListItemButton>
          <ListItemButton component = "a" href = "/constitution" sx={itemSx}>
            <ListItemText primary="Constitution" primaryTypographyProps={textSx}/>
          </ListItemButton>
          <ListItemButton component = "a" href = "/scholarship" sx={itemSx}>
            <ListItemText primary = "Scholarship" primaryTypographyProps={textSx}/>
          </ListItemButton>
          <ListItemButton component = "a" href = "/links" sx={itemSx}>
            <ListItemText primary = "Links" primaryTypographyProps={textSx}/>
          </ListItemButton>
          <ListItemButton component = "a" href = "/gallery" sx={itemSx}>
            <ListItemText primary = "Gallery" primaryTypographyProps={textSx}/>
          </ListItemButton>
          <ListItemButton component = "a" href = "/ate-kuya" sx={itemSx}>
            <ListItemText primary = "Ate/Kuya" primaryTypographyProps={textSx}/>
          </ListItemButton>

        </List>
        
      </Dialog>
    </div>
  );
}

export default MainMenu;